import { IAppState, TActions } from '../../common/state';
import { jq } from '../../json_query';

export interface IWithPhotoChangedAction {
  type: 'filters/with_photo/WITH_PHOTO_CHANGED';
  value: boolean | undefined;
}

export function changeWithPhoto(value: boolean | undefined): IWithPhotoChangedAction {
  return {
    type: 'filters/with_photo/WITH_PHOTO_CHANGED',
    value,
  };
}

export function withPhotoReducer(state: IAppState, action: TActions): IAppState {
  const jsonQuery = jq(state.filters.jsonQuery);

  switch (action.type) {
    case 'filters/with_photo/WITH_PHOTO_CHANGED':
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: jsonQuery.setWithPhoto(action.value || undefined),
        },
      };

    case 'filters/tags/TAG_REMOVED':
      if (action.tag.type === 'advanced-withPhoto') {
        return {
          ...state,
          filters: {
            ...state.filters,
            jsonQuery: {
              ...state.filters.jsonQuery,
              wp: undefined,
            },
          },
        };
      }

      return state;

    case 'filters/tags/ALL_TAGS_REMOVED':
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: {
            ...state.filters.jsonQuery,
            wp: undefined,
          },
        },
      };

    default:
      return state;
  }
}
